import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonComponent',
  props: {
    styleType: {},
    goTo: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_ctx.goTo)
    ? (_openBlock(), _createBlock(_component_RouterLink, {
        key: 0,
        to: _ctx.goTo,
        class: _normalizeClass(["button", `button-type-${_ctx.styleType || 'confirm'}`])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _: 3
      }, 8, ["to", "class"]))
    : (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: _normalizeClass(["button", `button-type-${_ctx.styleType || 'confirm'}`])
      }, [
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 2))
}
}

})